import type { IconProps } from './types';
import './icons.css';

export default function DropdownUp({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 7}
      height={height || 4}
      viewBox="0 0 7 4"
      className={`icon icon-dropdown-up ${className || ''}`}
    >
      <path
        fill="currentColor"
        d="m3.372.413 2.477 2.753A.5.5 0 0 1 5.477 4H.523a.5.5 0 0 1-.372-.834L2.628.413a.5.5 0 0 1 .744 0Z"
      />
    </svg>
  );
}
